import AddressManual from './components/AddressManual';
import AddressFieldPostcodeProvider from './context';

import { AddressFieldType } from '..';

export interface AddressFieldsProps {
  addressType: AddressFieldType;
}

const AddressFields: React.FunctionComponent<AddressFieldsProps> = function ({
  addressType,
}) {
  return (
    <AddressFieldPostcodeProvider addressType={addressType}>
      <AddressManual />
    </AddressFieldPostcodeProvider>
  );
};

export default AddressFields;
